import { useEffect } from 'react'
import { useDashboardStore } from '../stores/dashboardStore'
import { useAutoSaveView } from '../stores/viewsStore'
import { ViewTabs } from './ViewTabs'
import { TableToolbar } from './TableToolbar'
import { OrderTable } from './OrderTable'
import { OrderDetailPanel } from './OrderDetailPanel'

export function DashboardLayout() {
  const selectedOrderId = useDashboardStore((s) => s.selectedOrderId)
  const selectOrder = useDashboardStore((s) => s.selectOrder)

  useAutoSaveView()

  // Escape closes the detail panel
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape' && selectedOrderId !== null) {
        selectOrder(null)
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [selectedOrderId, selectOrder])

  return (
    <div className="flex flex-1 h-full overflow-hidden -m-6">
      {/* Left panel — tabs + toolbar + table */}
      <div
        className={`flex flex-col overflow-hidden transition-[flex] duration-200 ${
          selectedOrderId !== null ? 'flex-[0_0_75%]' : 'flex-1'
        }`}
      >
        <div className="pt-1" />
        <div className="px-4 pb-4 flex flex-col flex-1 overflow-hidden">
          <ViewTabs />
          <div className="flex flex-col flex-1 overflow-hidden bg-white rounded-xl border border-gray-200 shadow-sm">
            <TableToolbar />
            <div className="flex-1 overflow-hidden">
              <OrderTable />
            </div>
          </div>
        </div>
      </div>

      {/* Right panel — only visible when order selected */}
      {selectedOrderId !== null && (
        <div className="flex-[0_0_25%] border-l border-gray-200 bg-white overflow-y-auto">
          <OrderDetailPanel />
        </div>
      )}
    </div>
  )
}
